import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinningLogo = _resolveComponent("SpinningLogo")!
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_AppsRenderer = _resolveComponent("AppsRenderer")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.loading)
      ? (_openBlock(), _createBlock(_component_SpinningLogo, { key: 0 }))
      : (!_ctx.state.error && _ctx.renderedApp)
        ? (_openBlock(), _createBlock(_component_AppsRenderer, {
            key: 1,
            "rendered-app": _ctx.renderedApp,
            context: _ctx.context,
            onModalToggle: _ctx.toggleBackgroundOverlay
          }, {
            above: _withCtx(() => [
              (!_ctx.titleBarPlugin || !_ctx.titleBarPlugin.hidden)
                ? (_openBlock(), _createBlock(_component_TitleBar, {
                    key: 0,
                    disabled: _ctx.state.backgroundOverlay,
                    appId: _ctx.renderedApp.appId,
                    data: _ctx.titleBarPlugin
                  }, null, 8, ["disabled", "appId", "data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rendered-app", "context", "onModalToggle"]))
        : (_openBlock(), _createBlock(_component_Error, {
            key: 2,
            error: _ctx.state.error,
            onConfirm: _ctx.logout
          }, null, 8, ["error", "onConfirm"]))
  ]))
}